import { apm } from "@elastic/apm-rum";
import { ChevronRight, Close } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import React from "react";

import { monitor } from "shared/common/services/apm-logging";
import { defaultStore } from "shared/common/stores/defaultStore";
import { sidebarStore } from "shared/common/stores/sidebarStore";

export default function SmallToolContent() {
  // What does this name mean? 12
  const darkTheme = defaultStore((state) => state.darkTheme);

  const changeMeasurementPopover = sidebarStore(
    (state) => state.changeMeasurementPopover
  );
  const closeAllToolPopover = sidebarStore(
    (state) => state.closeAllToolPopover
  );
  const smallToolContent = sidebarStore((state) => state.smallToolContent);
  const changeShowSmallToolContent = sidebarStore(
    (state) => state.changeShowSmallToolContent
  );

  //close small tool
  const handleClose = () => {
    closeAllToolPopover();
    changeShowSmallToolContent(false);
  };

  //close small tool and measurement and open popover
  const handleToolSmallWindow = () => {
    handleClose();
    changeMeasurementPopover(true);
    changeShowSmallToolContent(false);
  };

  return (
    <Box
      position={"absolute"}
      left="calc(100% + 8px)"
      top="120px"
      display={"flex"}
      flexDirection={"row"}
      alignItems={"start"}
      sx={{
        backgroundColor: darkTheme ? "darkblue.main" : "white",
        borderRadius: "8px",
        zIndex: -1,
      }}
    >
      {smallToolContent && smallToolContent.content && (
        <Box padding={1} width="auto">
          {smallToolContent.content}
        </Box>
      )}
      <Box
        display={"flex"}
        flexDirection="row"
        gap={1}
        paddingX={1}
        alignItems="center"
        sx={{ color: darkTheme ? "white" : "darkblue.main" }}
      >
        <IconButton
          sx={{
            padding: 0,
            marginY: 1,
            color: darkTheme ? "white" : "darkblue.main",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
          onClick={() =>
            monitor(apm, "arrow-normal-window | Measure", handleToolSmallWindow)
          }
          disableRipple={true}
        >
          <ChevronRight />
        </IconButton>
        <IconButton
          sx={{
            padding: 0,
            marginY: 1,
            color: darkTheme ? "white" : "darkblue.main",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
          onClick={() =>
            monitor(apm, "close-small-window | Measure", handleClose)
          }
          disableRipple={true}
        >
          <Close />
        </IconButton>
      </Box>
    </Box>
  );
}
